export const checkEmptyFields = (object: AnyObject): boolean => {
  return Boolean(Object.values(object).some((value) => value == null));
};
